import { render, staticRenderFns } from "./goodsGroupUpdate.vue?vue&type=template&id=3c22f3d3&scoped=true&"
import script from "./goodsGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./goodsGroupUpdate.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroupUpdate.vue?vue&type=style&index=0&id=3c22f3d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22f3d3",
  null
  
)

export default component.exports